export const environment = {
  production: false,
  baseUrl: 'https://designguide.redebanvd.net',
  host: 'Develop',
};